export class TypesafeEventTarget<EventTypes extends {}> extends EventTarget {
  dispatch<Type extends keyof EventTypes & string>(type: Type, detail: EventTypes[Type]) {
    this.dispatchEvent(new CustomEvent(type, { detail }));
  }

  on<Type extends keyof EventTypes & string>(type: Type, callback: (data: { detail: EventTypes[Type] }) => void) {
    this.addEventListener(type, callback as any);
  }

  off<Type extends keyof EventTypes & string>(type: Type, callback: (data: { detail: EventTypes[Type] }) => void) {
    this.removeEventListener(type, callback as any);
  }
}
